/**
 * 도메인 부트스트래퍼 실행 순서 SSoT — GameScene.buildUi()가 이 배열을 순서대로 install한다.
 *
 * 신규 도메인 추가 = <domain>Boot.ts 1파일 + 여기 1줄 (GameScene 무접촉).
 * 빌드별 비활성 도메인(featureFlags)은 각 설치자 내부 또는 호출자 필터로 — 현재는 전 도메인 상시.
 * 분해 로드맵(S1~S6)에 따라 grid/economy/dungeon/dailyShop/iap/settings 설치자가 순차 합류한다.
 */
import type { DomainBootstrapper } from "./BootTypes.js";
import { codexBoot } from "./codexBoot.js";
import { economyBoot } from "./economyBoot.js";
import { statUpgradeBoot } from "./statUpgradeBoot.js";
import { spaceshipBoot } from "./spaceshipBoot.js";
import { rebirthBoot } from "./rebirthBoot.js";
import { relicBoot } from "./relicBoot.js";
import { dungeonBoot } from "./dungeonBoot.js";
import { settingsBoot } from "./settingsBoot.js";
import { composeBoot } from "./composeBoot.js";
import { moduleMasteryBoot } from "./moduleMasteryBoot.js";
import { battleBoot } from "./battleBoot.js";
import { mysteryBoot } from "./mysteryBoot.js";
import { recordBoot } from "./recordBoot.js";
import { worldBoot } from "./worldBoot.js";

export const BOOT_SEQUENCE: readonly DomainBootstrapper[] = [
  battleBoot, // 전투 그리드 탭(resident) + GridCommands 결선 + api{grid 7종} (S6 전반)
  codexBoot,
  economyBoot,
  statUpgradeBoot,
  spaceshipBoot,
  rebirthBoot,
  relicBoot,
  dungeonBoot, // featureFlags.dungeon — runBootSequence isEnabled 게이트
  composeBoot, // 합성/융합 탭 + Merge/FusionCommands + api{merge/fuse} (S2c 후반)
  moduleMasteryBoot, // 모듈 숙련도 탭 — 누적 카운터 노드 해금 + A/B 분기 선택 (v21)
  recordBoot, // 교신 기록 탭 — 이미 본 다이어로그 수평 카드 + 리플레이
  worldBoot, // 월드 탭 — 클리어한 월드 재진입 + 환생 범위 회차 초기화
  mysteryBoot, // 미스터리(?) 블록 일일 보상(다이아·유물) 자정 리셋 (전용 탭/api 없음)
  settingsBoot, // 설정·치트·QA대시보드 모달 조립 + api{toggleSettings} (S4c)
];
